import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customCapacity',
})
export class CustomCapacityPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) return '';
    // Caso: ya tiene formato "nuevo" (contiene "KG" y "L")
    // Caso: formato tipo FOREIGN_20#10#10
    const [total, ...comps] = value.split('_')[1].split('#');
    const strcomps = comps.join('-');
    return `${total}000 L (${strcomps})`;
  }
}
